module.exports = __webpack_public_path__ + "img/banner2.57a7c21.png";